export default "__VITE_ASSET__$rIHQavX__"